module.exports = __webpack_public_path__ + "assets/fcb581a2030068fe3c2be672007d27fb.png";